<template>
  <va-input v-if="input" v-bind="$props" class="va-array-input">
    <draggable :value="input" draggable=".item" handle=".handle" @input="update">
      <div v-for="(item, i) in input" :key="item.id" class="item pb-2 pt-2 mb-0">
        <v-row>
          <!--
          @slot Your repeatable group of inputs components.
          @binding {string} resource Name of resource.
          @binding {object} item Object item of array.
          @binding {string} parentSource Original array source.
          @binding {number} index Index of item inside array.
        -->
          <slot :resource="resource" :item="item" :parent-source="source" :index="i"></slot>
          <v-col class="pl-3">
            <div v-if="!disableSort" class="d-inline">
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn outlined icon text class="handle mt-2 mr-4 mb-2" v-on="on">
                    <v-icon small>mdi-cursor-move</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('va.actions.move') }}</span>
              </v-tooltip>
            </div>
            <div class="d-inline">
              <v-btn outlined icon color="red" small @click.stop="remove(i)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <v-btn slot="footer" outlined color="green" @click.stop="add">
        <v-icon>mdi-plus-circle-outline</v-icon>
        <span class="ml-2">{{ $t('va.actions.add') }}</span>
      </v-btn>
    </draggable>
  </va-input>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import { generateUid } from '@ilteducation/uid';

/**
 * Allow multiple embed inputs as array. See it as a repeater.
 * Support adding, removing, as well as moving via drag thanks to VueDraggable.
 */
export default {
  mixins: [Input],
  props: {
    /**
     * List of object to edit.
     * @model
     */
    value: {
      type: Array,
      default: () => [],
    },
    /**
     * Parameter to define identifier format: generate uuid or simple incremental numbers.
     */
    generateUid: {
      type: Boolean,
      default: true,
    },
    /**
     * Hide the drag handle, for arrays whose order carries no meaning.
     * Dragging is only possible through the handle, so this disables it.
     */
    disableSort: Boolean,
  },
  methods: {
    getItem(value) {
      /**
       * Generate fake id for drag tracking
       */
      return (value || []).map((v, i) => ({
        ...v,
        id: v.id || (this.generateUid ? generateUid() : i),
      }));
    },
    add() {
      let id;
      if (this.generateUid) {
        id = generateUid();
      } else {
        id = this.input.length ? Math.max(...this.input.map((o) => o.id)) + 1 : 0;
      }
      this.input.push({ id });
      this.update(this.input);
    },
    remove(index) {
      this.input.splice(index, 1);
      this.update(this.input);
    },
    replace(index, value) {
      this.remove(index);
      this.input.push(value);
      this.update(this.input);
    },
  },
};
</script>

<style>
.va-array-input > .v-input__control > .v-input__slot {
  display: block;
}
.va-array-input > .v-input__control > .v-input__slot > .v-label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

.item {
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;
  border-bottom: solid 1px var(--v-primary-lighten5);
  margin-bottom: 2rem;
}
</style>
